import { fetchFromServer } from "./serverClient";

export async function getJob(jobId) {
    return await fetchFromServer(`job/${jobId}`).then(res => res.json());
}
